'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _redux = require('redux');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _inout = require('../actions/inout');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_FILTER = {
    date: [(0, _moment2.default)().format('YYYY-MM') + '-01', (0, _moment2.default)().format('YYYY-MM-DD')]
};
var filter = function filter() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_FILTER;
    var action = arguments[1];

    switch (action.type) {
        case _inout.FILTER_INOUT:
            return Object.assign({}, state, action.filter);
        default:
            return state;
    }
};

var INITIAL_STATE = {
    isFetching: false,
    didInvalidate: false,
    items: []
};
var inouts = function inouts() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    switch (action.type) {
        case _inout.INVALIDATE_INOUT:
            return _extends({}, state, {
                didInvalidate: true
            });
        case _inout.REQUEST_INOUT:
            return _extends({}, state, {
                isFetching: true,
                didInvalidate: false
            });
        case _inout.RECEIVE_INOUT:
            return _extends({}, state, {
                isFetching: false,
                didInvalidate: false,
                items: action.inouts,
                lastUpdated: action.received_at
            });
        case _inout.FAILURE_INOUT:
            return _extends({}, state, {
                isFetching: false,
                error: action.error
            });
        default:
            return state;
    }
};

var inoutReducer = (0, _redux.combineReducers)({
    inouts: inouts,
    filter: filter
});

exports.default = inoutReducer;


//////////////////
// WEBPACK FOOTER
// ./src/js/reducers/inout.js
// module id = 887
// module chunks = 0